
import { useState } from "react";

export const useVerificationState = () => {
  const [showOTP, setShowOTP] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [verified, setVerified] = useState(false);
  const [loading, setLoading] = useState(false);

  const resetState = () => {
    setShowOTP(false);
    setError(null);
    setSuccess(null);
  };

  return {
    showOTP,
    error,
    success,
    verified,
    loading,
    setShowOTP,
    setError,
    setSuccess,
    setVerified,
    setLoading,
    resetState,
  };
};
